import React from 'react'
import { withTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import * as UIcons from '@iconscout/react-unicons'
import Btn from 'components/Btn'

export default withTranslation()(function RecentTransactionsCard({ t, rows = [] }) {
  const navigate = useNavigate()

  return (
    <div className="w-full bg-white border border-border-lines rounded-2xl p-6 flex flex-col gap-4">
      <div className="flex items-center justify-between gap-4">
        <p className="text-xl font-semibold text-dark-blue">{t('billing.recent_transactions.title')}</p>

        <Btn
          content={() => <span className="flex items-center gap-2">{t('billing.recent_transactions.view_all')} <UIcons.UilArrowRight size={16} /></span>}
          className="text-white bg-primary rounded-full h-9 px-4 font-semibold text-sm whitespace-nowrap"
          click={() => navigate('/transactions')}
        />
      </div>

      <div className="w-full border border-border-lines rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-dark-blue bg-background">
                <th className="py-2.5 px-4 font-semibold uppercase whitespace-nowrap">{t('billing.recent_transactions.columns.date')}</th>
                <th className="py-2.5 px-4 font-semibold uppercase whitespace-nowrap">{t('billing.recent_transactions.columns.account')}</th>
                <th className="py-2.5 px-4 font-semibold uppercase whitespace-nowrap">{t('billing.recent_transactions.columns.description')}</th>
                <th className="py-2.5 px-4 font-semibold uppercase whitespace-nowrap">{t('billing.recent_transactions.columns.type')}</th>
                <th className="py-2.5 px-4 font-semibold uppercase whitespace-nowrap">{t('billing.recent_transactions.columns.amount')}</th>
                <th className="py-2.5 px-4 font-semibold uppercase whitespace-nowrap">{t('billing.recent_transactions.columns.balance')}</th>
              </tr>
            </thead>

            <tbody>
              {
                rows.length ? rows.map((row, index) => (
                  <tr key={row.id ?? index} className="border-t border-border-lines">
                    <td className="py-4 px-4 text-dark-blue whitespace-nowrap">{row.date}</td>
                    <td className="py-4 px-4 text-dark-blue whitespace-nowrap">{row.account}</td>
                    <td className="py-4 px-4 text-dark-blue">{row.description}</td>
                    <td className="py-4 px-4 text-dark-blue whitespace-nowrap">{row.type}</td>
                    <td className="py-4 px-4 text-dark-blue whitespace-nowrap">{row.amount}</td>
                    <td className="py-4 px-4 text-dark-blue whitespace-nowrap">{row.balance}</td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan={6} className="text-center py-12">
                      <p className="font-semibold text-dark-blue">{t('billing.recent_transactions.empty_title')}</p>
                      <p className="text-sm text-secondary mt-1">{t('billing.recent_transactions.empty_hint')}</p>
                    </td>
                  </tr>
                )
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
})
